import { isEmpty } from 'lodash-es'
import { useTranslations } from 'next-intl'

import {
  useValidateStep,
  THostInfoFormWithCertNum,
  useSignUpHostStore,
  TTermsForm,
  createZHostInfoForm,
} from '@/features/sign-up'

const HOST_STEP_PATHS: Record<string, number> = {
  intro: 0,
  terms: 1,
  info: 2,
  pay: 3,
  complete: 4,
}

const validateTermsStep = (terms: TTermsForm) => {
  const isRequiredAllChecked =
    terms.termsOfService && terms.privacyConsent && terms.ageOver19

  return isRequiredAllChecked
}

const validateHostInfoStep = (
  info: THostInfoFormWithCertNum,
  t: ReturnType<typeof useTranslations<'account'>>,
) => {
  const isVerified = !isEmpty(info.certNum) && !isEmpty(info.phoneNumber)

  const { success } = createZHostInfoForm(t).safeParse(info)

  return success && isVerified
}

export const useValidateHostStep = () => {
  const { terms, info } = useSignUpHostStore()

  const tAccount = useTranslations('account')

  useValidateStep(HOST_STEP_PATHS, [
    {
      step: 2,
      validate: () => validateTermsStep(terms),
      redirect: '/sign-up/host?step=terms',
    },
    {
      step: 3,
      validate: () => validateHostInfoStep(info, tAccount),
      redirect: '/sign-up/host?step=info',
    },
  ])
}
